export const actions = {
  setTrack(track, options = {}) {
    this.track = track ? { ...track } : null;
    this.isPlaying = options.autoplay !== false && track?.audioUrl;
  },

  setPlaying(value) {
    this.isPlaying = Boolean(value);
  },

  toggle() {
    this.isPlaying = !this.isPlaying;
  },

  setVolume(value) {
    const v = Math.max(0, Math.min(1, value));
    this.volume = v;
    if (v > 0) this.isMuted = false;
  },

  toggleMute() {
    if (this.isMuted) {
      this.volume = this.volumeBeforeMute;
      this.isMuted = false;
    } else {
      this.volumeBeforeMute = this.volume;
      this.volume = 0;
      this.isMuted = true;
    }
  },
};
